import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Row,
    Column,
    Button,
    cls,
    TranslationID
} from 'packages/components';
import './_styles.scss';
import { AUTHDEVICE } from '../utils/constants';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import Assets from '../../requests/apa/Asset';
import Translator from './../../requests/apa/Translator';
import { authdevice, loginByToken } from '../../requests/loader';
import { receiveAuthDevice } from '../../reducers/user';
import { autobind } from 'packages/core/lib';
import Utils from "src/utils/Utils";
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import { getAuthdeviceConfig, getEnableCMRExperience } from "../../utils/Utils";
import AAF from '../../AAF/AAF';

export enum AuthDeviceStatus {
    RETRYING = 'retrying',
    STANDBY = 'standby',
    READY = 'ready'
}

interface IAuthDeviceProps {
    user: any;
}

interface IAuthDeviceState {
    status: AuthDeviceStatus.READY | AuthDeviceStatus.RETRYING | AuthDeviceStatus.STANDBY;
}

class AuthDevice extends Component<RouteComponentProps & IAuthDeviceProps, IAuthDeviceState> {
    public headerLogo: string = Assets.get('logo_clarotv') || '';
    public warningIconName: string = 'resilence_warning_icon';
    public warningIcon: string = Assets.get(this.warningIconName);
    private translations: Record<TranslationID, string>;


    constructor(props: RouteComponentProps & IAuthDeviceProps) {
        super(props);
        
        if (this.isLoggedIn()){
            window.location.assign('/')
        }

        this.state = {
            status: AuthDeviceStatus.STANDBY
        };

        this.translations = {
            'resilence_warning_title_label': Translator.get('resilence_warning_title_label', ''),
            'resilence_warning_waitMessage_label': Translator.get('resilence_warning_waitMessage_label', 'Por favor espera unos minutos.'),
            'resilence_warning_button_retry': Translator.get('resilence_warning_button_retry', 'REINTENTAR'),
            'resilence_warning_tryMessage_label': Translator.get('resilence_warning_tryMessage_label', 'Gracias por la espera, por favor intenta de nuevo.')
        };
    }

    public componentDidMount() {
        if (this.isLoggedIn()){
            this.unsetSuccessfullAppLoad();
        }else {
            this.setDefaultFocus();
            this.setTimeout();
            this.setSuccessfullAppLoad();
        }
    }


    @autobind
    public callAuthdeviceApi() {
        return authdevice()
            .then((result: any) => this.authdeviceApiSuccess(result))
            .catch(err => this.authdeviceApiError(err))
            .finally(() => { this.setState({ status: AuthDeviceStatus.STANDBY }) });
    }

    //* Funcion para llamar a la nueva API callLoginByTokenAPI
    public callLoginByTokenAPI() {
        return loginByToken()
            .then((result: any) => this.loginByTokenSuccess(result))
            .catch(err => this.loginByTokenError(err))
            .finally(() => { this.setState({ status: AuthDeviceStatus.STANDBY }) });
    }

    @autobind
    public authdeviceApiSuccess(result: any) {
        const { response = false, response: user = {} } = result || {};
        if (response) {
            DeviceStorage.setItem('fromAuthDevice', 'true');
        }

        const { subregion = false, session_userhash = false } = user;
        subregion && DeviceStorage.setItem('sub_region', subregion);

        if (session_userhash) {
            this.unsetSuccessfullAppLoad()
            this.setAppSessionUserHash(session_userhash)
            this.props.receiveAuthDevice(user);
            Utils.setCustomAttribute();
        }
    }

    //* Funcion para setear el user_token en el store
    public loginByTokenSuccess(result: any) {
        console.log('[AuthDeviceModal]:: loginByTokenSuccess result', result);
        const userData = result.data ? result.data : {};
        console.log('[AuthDeviceModal]:: success', userData);

        if (userData) {
            const { subregion = false, session_userhash = false, user_token = false } = userData;

            //* Se obtiene el user_token y se guarda en el store
            DeviceStorage.setItem('user_token', user_token);
            AAF.Database.setUserToken(user_token);
            DeviceStorage.setItem('fromAuthDevice', 'true');
            subregion && DeviceStorage.setItem('sub_region', subregion);

            if (session_userhash) {
                console.log('[AuthDeviceModal]:: loginByTokenSuccess session_userhash', session_userhash);
                this.unsetSuccessfullAppLoad()
                this.setAppSessionUserHash(session_userhash)
                this.props.receiveAuthDevice(userData);
                Utils.setCustomAttribute();
            }
        }
    }

    @autobind
    public authdeviceApiError(err: any) {
        console.log('[AuthDeviceModal]:: authdeviceApiError', err);

        const { completeError: { errors: { code = '' } = {} } = {} } = err || {};

        if (code == '703000001') {
            const user = { ptv_url: err.completeError.response };
            DeviceStorage.setItem('missingEmail', 'true');
            this.props.receiveAuthDevice(user);
        }
    }

    public loginByTokenError(err: any) {
        console.log('[AuthDeviceModal]:: loginByTokenError', err);
        const { errors: { code = '' } = {} = {} } = err || {};

    }

    setAppSessionUserHash(userhash: string) {
        DeviceStorage.setItem('user_hash', userhash);
    }

    setSuccessfullAppLoad() {
        DeviceStorage.setItem('successfulAppLoad', 'true');
    }

    unsetSuccessfullAppLoad() {
        DeviceStorage.unsetItem('successfulAppLoad');
    }

    private getConfig() {
        return getAuthdeviceConfig()
    }

    private setTimeout() {
        let minutes;

        // Validate if CRM experience is enable
        const { enable, loginByToken_retry } = getEnableCMRExperience() || {};
        if (enable) {
            minutes = loginByToken_retry.timer_minutes;
        } else {
            const { timer_minutes = 10 } = this.getConfig() || {};
            minutes = timer_minutes;
        }
        const timeout = parseInt(minutes, 10) * 60000

        setTimeout(() => {
            this.setState({ status: AuthDeviceStatus.READY });
        }, timeout)
    }


    private setDefaultFocus() {
        setTimeout(() => {
            window.SpatialNavigation.focus('a.focusable');
        }, 5000)
    }

    handleSubmmit = async (): Promise<void> => {
        const { status } = this.state;
        const { enable } = getEnableCMRExperience() || {};

        console.log('[AuthDeviceModal]:: status', status, getEnableCMRExperience(), enable);
        if (status === AuthDeviceStatus.READY) {
            this.setState({ status: AuthDeviceStatus.RETRYING });
            console.log('[AuthDeviceModal]:: handleSubmmit click en el boton retry');

            if (enable) {
                //* Se manda API callLoginByTokenAPI
                this.callLoginByTokenAPI();
            } else {
                this.callAuthdeviceApi();
            }
            this.setTimeout();
        }
    };

    private isLoggedIn() {
        const {user : {isLoggedIn = false}} = this.props || {};
        return isLoggedIn;
    }

    private withEllipsis(text: string, maxLength: number) {
        if(text.length > maxLength) {
            return text.slice(0, maxLength - 3).concat("...");
        }
        return text
    }


    public render(): JSX.Element | null {
        const { status } = this.state;
        const description = status === AuthDeviceStatus.READY ?
            this.translations.resilence_warning_tryMessage_label :
            this.translations.resilence_warning_waitMessage_label;

        if (this.isLoggedIn()){
            return null
        }

        return (
            <Grid className={cls(`${AUTHDEVICE}-grid`)}>
                <Row className={cls(`${AUTHDEVICE}-row`)}>
                    <Column lg={3} className={cls(`${AUTHDEVICE}-header-logo`)}>
                        <img src={this.headerLogo} alt="claroTv logo" />
                    </Column>
                </Row>
                <Row className={cls(`${AUTHDEVICE}-row`)}>
                    <Column lg={3}>
                    </Column>
                    <Column lg={6} className={cls(`${AUTHDEVICE}-warning-icon`)}>
                        {this.warningIconName !== this.warningIcon &&
                        <img src={this.warningIcon} alt="Warning Icon" />
                        }
                    </Column>
                    <Column lg={3}>
                    </Column>
                </Row>
                
                { this.translations && this.translations.resilence_warning_title_label && (
                    <Row className={cls(`${AUTHDEVICE}-row`)}>
                        <Column lg={12} className={cls(`${AUTHDEVICE}-title`)}>
                            <span>{this.withEllipsis(this.translations.resilence_warning_title_label, 50)}</span>
                        </Column>    
                    </Row>
                )}
                <Row className={cls(`${AUTHDEVICE}-row`)}>
                    <Column lg={2}>
                    </Column>
                    <Column lg={8} className={cls(`${AUTHDEVICE}-description`)}>
                        <span>{this.withEllipsis(description, 216)}</span>
                    </Column>
                    <Column lg={2}>
                    </Column>
                </Row>
                <Row className={cls(`${AUTHDEVICE}-row`)}>
                    <Column lg={3}>
                    </Column>
                    <Column lg={6} className={cls(`${AUTHDEVICE}-buttons`)}>
                        <Button
                            activate
                            type="button"
                            variant="primary"
                            className={cls(`focusable`, `button-container`, status === AuthDeviceStatus.READY ? 'active' : 'inactive')}
                            onClick={this.handleSubmmit}
                        >
                            {this.translations.resilence_warning_button_retry}
                        </Button>
                    </Column>
                    <Column lg={3}>
                    </Column>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            receiveAuthDevice
        },
        dispatch
    );

export default withRouter(connect(null, mapDispatchToProps)(AuthDevice));


// WEBPACK FOOTER //
// ./src/authentication/AuthDevice/index.tsx